import React from 'react'
import FormHelperText from '@material-ui/core/FormHelperText'

const CharacterCount = ({ characterCount, maxCharacters }) => (
  <FormHelperText>{`${characterCount} of ${maxCharacters}`}</FormHelperText>
)

export default CharacterCount
